import { Component } from "react";
import { Panel } from 'react-bootstrap';
import Tools from "../libs/tools";

export class EnlacesDirectosColapsable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      configurations: {},
      principalDirectLink: [],
      secundaryDirectLink: [],
      currentAlert: ""
    };
    this.tools = new Tools();
    this.getDirectLinks = this.getDirectLinks.bind(this);
    this.collapsePanelDirectLinks = this.collapsePanelDirectLinks.bind(this);
  }

  componentDidMount() {
    this.setState({ configurations: this.props.configurations });
    this.getDirectLinks();
  }

  getDirectLinks() {
    const resultUrl = this.props.serviceUrl.toLowerCase();
    const contentType = this.tools.setContentType();
    const directLinksService = new ServicioProxy(
      "ObtenerEnlacesDirectos?home=" + resultUrl + "&contenido=" + contentType,
      "ServicioConsorcioHomes.svc"
    );
    directLinksService
      .getElements("POST", {})
      .then(response => {
        const data = JSON.parse(response);
        console.log('data enalces', data);
        if (data.length > 3) {
          const principalDirectLink = data.slice(0, 3);
          const secundaryDirectLink = data;
          this.setState({
            principalDirectLink: principalDirectLink,
            secundaryDirectLink: secundaryDirectLink
          });
        } else {
          const principalDirectLink = data.slice(0, 3);
          this.setState({
            principalDirectLink: principalDirectLink,
            secundaryDirectLink: 0
          });
        }
      })
      .catch(error => {
        /* this.props.errorMessage(); */
      });
  }

  collapsePanelDirectLinks() {
    this.setState({ open: !this.state.open });
    if (this.state.open && screen.width <= 768) {
      const elmnt = document.getElementById("enlacesDirectos");
      elmnt.scrollIntoView(true);
    }
  }

  getTitle() {
    return this.state.configurations["EnlacesDirectosTitulo"];
  }

  render() {
    const panelStyle = {
      borderBottom: "1px dotted #e2e2e2",
      paddingBottom: "30px",
      marginBottom: "20px"
    };
    return (
      <div>
        <div>
          {this.state.currentAlert === "messages" ? (
            <Mensajes
              msg={this.state.configurations["MensajeErrorDeServicios"]}
            />
          ) : null}
        </div>
        <div>
          {(this.state.secundaryDirectLink > 0 ||
            this.state.principalDirectLink) &&
          this.state.open === false ? (
            <div
              className="row contain-card"
              style={
                this.state.secundaryDirectLink != 0 ||
                this.state.principalDirectLink != 0
                  ? panelStyle
                  : null
              }
            >
              <div>
                {this.state.secundaryDirectLink != 0 ||
                this.state.principalDirectLink != 0 ? (
                  <h2>{this.getTitle()}</h2>
                ) : null}
              </div>
              <div className="principal-contain-card col-xs-12 col-md-12">
                {this.state.principalDirectLink.map(item => {
                  return (
                    <div className="col-xs-12 col-sm-3 col-md-3 card">
                      <h3>{item["Titulo"]}</h3>
                      <a href={item["Link"]}>
                        <div className="imageBox">
                          <img src={item["IconoServicioUrl"]} />
                        </div>
                      </a>
                      <button
                        onClick={() => (window.location.href = item["Link"])}
                        type="button"
                        className="btn btn-block btn-primary"
                      >
                        {item["BotonServicio"]}
                      </button>
                      <div className="separatorButtonCard" />
                    </div>
                  );
                })}
                {this.state.secundaryDirectLink.length > 0 &&
                this.state.open === false ? (
                  <div
                    className="col-xs-12 col-sm-3 col-md-3 card"
                    onClick={this.collapsePanelDirectLinks}
                  >
                    <div className="showMoreBackground">
                      <h3>Más Servicios</h3>
                      <div className="circle-gray">
                        {this.state.open === false ? (
                          <i className="fa fa-plus" />
                        ) : (
                          <i className="fa fa-minus" />
                        )}
                      </div>
                      <button
                        onClick={this.collapsePanelDirectLinks}
                        type="button"
                        className="btn btn-block btn-primary"
                      >
                        {this.state.open === false ? "Ver Más" : "Ver Menos"}
                      </button>
                      <div className="separatorButtonCard" />
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            <div
              className="row contain-card"
              style={
                this.state.secundaryDirectLink != 0 ||
                this.state.principalDirectLink != 0
                  ? panelStyle
                  : null
              }
            >
              <div>
                {this.state.secundaryDirectLink != 0 ||
                this.state.principalDirectLink != 0 ? (
                  <h2>{this.getTitle()}</h2>
                ) : null}
              </div>
              <Panel
                id="collapsible-panel-example-1"
                expanded={this.state.open}
              >
                <Panel.Collapse>
                  <div className="secundary-contain-card col-xs-12 col-md-12">
                    {this.state.secundaryDirectLink.map(item => {
                      return (
                        <div className="col-xs-12 col-sm-3 col-md-3 card">
                          <h3>{item["Titulo"]}</h3>
                          <a href={item["Link"]}>
                            <div className="imageBox">
                              <img src={item["IconoServicioUrl"]} />
                            </div>
                          </a>
                          <button
                            onClick={() =>
                              (window.location.href = item["Link"])
                            }
                            type="button"
                            className="btn btn-block btn-primary"
                          >
                            {item["BotonServicio"]}
                          </button>
                          <div className="separatorButtonCard" />
                        </div>
                      );
                    })}
                    {this.state.principalDirectLink.length > 2 &&
                    this.state.secundaryDirectLink.length > 0 &&
                    this.state.open === true ? (
                      <div
                        className="col-xs-12 col-sm-3 col-md-3 card"
                        onClick={this.collapsePanelDirectLinks}
                      >
                        <div className="showMoreBackgroundOpen">
                          <h3>Más Servicios</h3>
                          <div className="circle-gray">
                            {this.state.open === true ? (
                              <i className="fa fa-minus" />
                            ) : (
                              <i className="fa fa-plus" />
                            )}
                          </div>
                          <button
                            onClick={this.collapsePanelDirectLinks}
                            type="button"
                            className="btn btn-block btn-primary"
                          >
                            {this.state.open === true ? "Ver Menos" : "Ver Más"}
                          </button>
                          <div className="separatorButtonCard" />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </Panel.Collapse>
              </Panel>
            </div>
          )}
        </div>
      </div>
    );
  }
}
